function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import is from '../../../_snowpack/pkg/styled-is.js';
import { colors } from '../colors.js';
import { common } from '../common.js';
const Outer = styled.div.withConfig({
  displayName: "dropdown__Outer",
  componentId: "z5ocjy-0"
})(["display:inline-block;position:relative;width:100%;"]);
const DropdownCmp = styled.select.withConfig({
  displayName: "dropdown__DropdownCmp",
  componentId: "z5ocjy-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;appearance:none;-webkit-appearance:none;z-index:1;opacity:0;"]);
const DisplayText = styled.div.withConfig({
  displayName: "dropdown__DisplayText",
  componentId: "z5ocjy-2"
})(["padding-top:15px;padding-bottom:15px;padding-left:20px;min-width:100px;height:45px;&::after{content:'\u25BC';position:absolute;right:15px;top:17px;font-size:10px;margin-left:40px;}border:none;font-size:14px;background:#fff;color:", ";width:", ";outline:none;border-bottom:1px solid transparent;", " ", ";", ";", ";", ";", ";", ";", ";&:focus{border-bottom-color:", ";", ";}select:focus + &{border-color:", ";font-weight:600;width:100%;}"], colors.frostbite, p => p.width || '100%', is('default')`
    background:#fff;
    border-radius:25px;
    font-weight:600;
    width: 100%;
    position:relative;
    z-index:0;
  `, is('white')`
    background: #fff;
  `, is('line')`
    border-bottom: 1px solid ${colors.glacier};
    background: transparent;
  `, is('noBorder')`
    border: none;
  `, is('readOnly')`
    cursor: default;
  `, is('right')`
    text-align: right;
  `, is('fullWidth')`
    width: 100% !important;
    margin-right: 0;
  `, is('prefix')`
    border-left:${common.dottedBorder};
    border-radius:0 25px 25px 0;
  `, colors.glacierDarker, is('noBorder')`
    border: none;
  `, colors.glacierDarker);

function normalizeOption(option) {
  if (!option) {
    return {
      value: null,
      displayText: ''
    };
  }

  if (option.value) {
    return option;
  }

  return {
    value: option,
    displayText: option
  };
}

export class Dropdown extends React.Component {
  render() {
    const {
      value,
      options,
      default: sylDefault,
      fullWidth,
      prefix,
      ...rest
    } = this.props;

    if (!options) {
      return null;
    }

    const normalizedOptions = options.map(normalizeOption);
    const selectedOption = normalizedOptions.find(o => o.value === value) || normalizedOptions[0] || {};
    return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(DropdownCmp, _extends({
      value: value
    }, rest), normalizedOptions.map(o => /*#__PURE__*/React.createElement("option", {
      key: o.value,
      value: o.value
    }, o.displayText))), /*#__PURE__*/React.createElement(DisplayText, {
      default: sylDefault,
      fullWidth: fullWidth,
      prefix: prefix
    }, selectedOption.displayText));
  }

}